"use strict";
/**
 * @packageDocumentation
 * @module harmony-contract
 * @hidden
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractStatus = void 0;
var ContractStatus;
(function (ContractStatus) {
    ContractStatus["INITIALISED"] = "initialised";
    ContractStatus["TESTED"] = "tested";
    ContractStatus["ERROR"] = "error";
    ContractStatus["SIGNED"] = "signed";
    ContractStatus["SENT"] = "sent";
    ContractStatus["REJECTED"] = "rejected";
    ContractStatus["DEPLOYED"] = "deployed";
    ContractStatus["CALLED"] = "called";
})(ContractStatus = exports.ContractStatus || (exports.ContractStatus = {}));
//# sourceMappingURL=status.js.map